import { Loader, Select, type SelectProps } from "@mantine/core"
import { IconHash } from "@tabler/icons-react"
import { useQuery } from "@tanstack/react-query"
import { useTranslation } from "react-i18next"
import { fetchAPISlackChannels } from "@/utils"

export function SelectSlackChannel(props: SelectProps) {
  const { t } = useTranslation()
  const {
    data: channels = [],
    isLoading,
    refetch,
  } = useQuery({
    queryKey: ["slack-channels"],
    queryFn: fetchAPISlackChannels,
  })
  return (
    <Select
      searchable
      allowDeselect={false}
      disabled={isLoading}
      label={t("Slack channel")}
      placeholder={t("Select a channel")}
      {...props}
      data={channels.map((channel) => ({
        value: channel.id,
        label: channel.name,
      }))}
      leftSection={isLoading ? <Loader size={16} color="gray" /> : <IconHash size={16} color="gray" />}
      onDropdownOpen={() => {
        props.onDropdownOpen?.()
        refetch()
      }}
    />
  )
}
